import React from 'react';
import { getDefaultStandardsForRegion, getDefaultDescriptionForRegion } from './RegionalTemplateUtils';

/**
 * RegionalTemplateList component for displaying templates grouped by industry for a specific region
 * @param {Object} props - Component props
 * @param {Object} props.groupedTemplates - Templates grouped by industry
 * @param {string} props.activeTab - Currently active region tab
 * @param {string} props.selectedTemplate - ID of the currently selected template
 * @param {Function} props.handleTemplateSelection - Function to handle template selection
 * @param {Object} props.styles - Styles object for consistent styling
 */
const RegionalTemplateList = ({ 
  groupedTemplates, 
  activeTab, 
  selectedTemplate, 
  handleTemplateSelection, 
  styles 
}) => {
  return (
    <div style={styles.templateListContainer}>
      {Object.entries(groupedTemplates).map(([industry, industryTemplatesList]) => (
        <div key={industry} style={styles.industryGroup}>
          <h3 style={styles.industryTitle}>{industry}</h3>
          <div style={styles.templatesGrid}>
            {industryTemplatesList.map(template => {
              // Get standards text from template or use default based on region
              const standards = template.standards || 
                                template.applicableStandards || 
                                getDefaultStandardsForRegion(activeTab, template.industryType);
              
              // Get description from template or use default based on region
              const description = template.description || 
                                  getDefaultDescriptionForRegion(activeTab, template.industryType);
              
              return (
                <div 
                  key={template._id} 
                  style={{
                    ...styles.templateCard,
                    ...(selectedTemplate === template._id ? styles.selectedTemplateCard : {})
                  }}
                  onClick={() => handleTemplateSelection(template._id)}
                >
                  <div>
                    <div style={styles.templateTitle}>{template.name}</div>
                    <div style={styles.templateDescription}>{description}</div>
                    <div style={styles.standardsContainer}>
                      <span style={styles.standardsLabel}>Standards & Regulations:</span> <span style={styles.standardsList}>{standards}</span>
                    </div>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <span style={styles.templateIndustry}>{template.industryType}</span>
                    <span style={styles.templateQuestions}>
                      {template.questions ? template.questions.length : (template.questionCount || '100+')} Questions
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
      
      {Object.keys(groupedTemplates).length === 0 && (
        <div style={styles.noTemplatesMessage}>
          <p>No templates available for this region.</p>
          <p>Please select another region or contact your administrator.</p>
        </div>
      )}
    </div>
  );
};

export default RegionalTemplateList;
